import { fromJS } from 'immutable';
import actions from '../constants';

const initialState = fromJS({});

const update = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_FINISH:
      return fromJS(action.payload || {});
    case actions.GET_ERROR:
      return fromJS({});
    case actions.CREATE_FINISH:
      return state.merge(action.payload);
    case actions.DELETE_FINISH:
      return state.delete(action.payload);
    default:
      return state;
  }
};

export default update;



// WEBPACK FOOTER //
// ./src/modules/sessions/reducers/entities.js